import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import QuoteSection from '../components/QuoteSection';
import LightboxModal from '../components/LightboxModal';
import { imageUrl } from '../lib/images';

export default function RionetPage() {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const images = [
    { src: "/_assets/pxl-20260709-112402346.jpg", title: "Rionethegn om køkkenhave" },
    { src: "/_assets/pxl-20260709-112353116.jpg", title: "Rionethegn vinkel ved bede" },
    { src: "/_assets/pxl-20260709-112346689.jpg", title: "Rionet og højbede" },
    { src: "/_assets/pxl-20260413-100655471.jpg", title: "Trådhegn og komposithegn ved gult hus" },
    { src: "/_assets/480220622-1283354609819403-454519828912243296-n-0.jpg", title: "Rionethegn" },
    { src: "/_assets/rio3.jpeg", title: "Rionet i have" },
    { src: "/_assets/rionet-6.jpeg", title: "Rionethegn med stolper" },
    { src: "/_assets/315981588-673995694088634-4081471569169952651-n.jpg", title: "Galvaniseret rionet" },
  ];

  const fordele = [
    { title: "Vedligeholdelsesfrit", desc: "kræver ingen maling eller behandling." },
    { title: "Lang levetid", desc: "galvaniseret stål sikrer holdbarhed og modstandsdygtighed mod vejr og vind." },
    { title: "Fleksibel løsning", desc: "kan bruges alene eller kombineres med fx komposithegn." },
    { title: "Sikkert valg", desc: "ideelt til at holde hunde og andre dyr på egen grund." },
    { title: "Æstetisk mulighed", desc: "perfekt som espalier til klatreplanter, hvilket giver et grønnere og mere naturligt udtryk." },
    { title: "Forskellige størrelser", desc: "leveres i mange mål, så hegnet kan tilpasses behovet." },
  ];

  return (
    <>
      <SEO
        title="Rionet – enkelt og vedligeholdelsesfrit | Hovendals"
        description="Rionet til have og hegn Rionet er en god løsning, hvis hunden skal blive på grunden, eller hvis der skal sikres omkring husstanden. Der findes mange løsninger i rionet, og mulighederne er næsten ikke begrænset, om det er lidt beplanting der skal gro op af rionetet, eller du vil supplere dit komposithegn med et par rionet fag i mellem."
        ogImage="/_assets/480220622-1283354609819403-454519828912243296-n.jpg"
      />

      {/* Hero */}
      <section className="relative py-20 bg-slate-900 text-white overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-25">
          <img
            src={imageUrl("/_assets/480220622-1283354609819403-454519828912243296-n.jpg", "width=1600,quality=80,format=auto")}
            alt="Rionet hegn"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-[#004fa4]/20 text-[#c2ccdf] border border-[#004fa4]/30">
              <i className="fa-sharp fa-solid fa-grid-2" aria-hidden="true"></i>
              <span>Rionethegn</span>
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-tight">
              Rionet – enkelt og vedligeholdelsesfrit
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed font-normal">
              Rionet er en stærk og funktionel løsning til afgrænsning af haven, klatreplanter og tryghed for husstandens firbenede venner.
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div className="space-y-6">
              <div>
                <span className="text-xs font-bold uppercase tracking-wider text-[#004fa4]">Have & afgrænsning</span>
                <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight mt-1">
                  Rionet til have og hegn
                </h2>
              </div>
              <p className="text-slate-700 leading-relaxed text-base">
                Rionet er en god løsning, hvis hunden skal blive på grunden, eller hvis der skal sikres omkring husstanden. Der findes mange løsninger i rionet, og mulighederne er næsten ikke begrænset, om det er lidt beplanting der skal gro op af rionetet, eller du vil supplere dit <Link to="/komposithegn" className="text-[#004fa4] font-bold hover:underline">komposithegn</Link> med et par rionet fag i mellem.
              </p>

              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">
                  Galvaniseret rionet – en stærk og vedligeholdelsesfri løsning
                </h3>
                <p className="text-slate-700 leading-relaxed text-base">
                  Galvaniseret rionet er endnu en af de vedligeholdelsesfrie løsninger der tilbydes, og kommer i mange størrelser. Rionet kommer med stål stolper, og anbefales også hvis man ønsker en lang levetid. Rionet hegn er veligholelsesfrit.
                </p>
              </div>

              <div className="pt-2">
                <Link
                  to="/kontakt"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-[#004fa4] hover:bg-[#183e7f] text-white font-medium text-sm shadow-sm transition-all"
                >
                  <span>Få et uforpligtende tilbud på rionet</span>
                  <i className="fa-sharp fa-solid fa-arrow-right text-xs" aria-hidden="true"></i>
                </Link>
              </div>
            </div>

            <div className="relative rounded-2xl overflow-hidden shadow-xl border-4 border-white bg-slate-100">
              <img
                src={imageUrl("/_assets/480220622-1283354609819403-454519828912243296-n-0.jpg", "width=800,quality=85,format=auto")}
                alt="Rionet hegn"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          {/* Fordele ved rionet hegn */}
          <div className="bg-slate-50 rounded-2xl p-8 sm:p-12 border border-slate-200/80 mb-16">
            <h3 className="text-2xl sm:text-3xl font-extrabold text-slate-900 mb-6">
              Fordele ved rionet hegn:
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {fordele.map((f, i) => (
                <div key={i} className="p-5 rounded-xl bg-white border border-slate-200 shadow-sm space-y-2">
                  <div className="w-8 h-8 rounded-lg bg-[#004fa4]/10 text-[#004fa4] flex items-center justify-center text-sm font-bold">
                    <i className="fa-sharp fa-solid fa-check" aria-hidden="true"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 text-base">{f.title}</h4>
                  <p className="text-slate-600 text-sm leading-relaxed">{f.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Galleri */}
          <div className="mb-12">
            <h3 className="text-2xl font-bold text-slate-900 mb-2">
              Rionet galleri
            </h3>
            <p className="text-sm text-slate-600 mb-6">
              Se fotos af rionet opsætning med stålstolper.
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              {images.map((img, idx) => (
                <div
                  key={idx}
                  onClick={() => setLightboxIndex(idx)}
                  className="group relative h-48 rounded-xl overflow-hidden bg-slate-100 cursor-pointer shadow-sm hover:shadow-md transition-all"
                >
                  <img
                    src={imageUrl(img.src, "width=500,quality=80,format=auto")}
                    alt={img.title}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-slate-950/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center text-white">
                    <span className="p-2 rounded-full bg-[#143463]/90 text-white text-xs">
                      <i className="fa-sharp fa-solid fa-magnifying-glass-plus" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <QuoteSection />

      {/* Lightbox modal */}
      <LightboxModal
        images={images}
        currentIndex={lightboxIndex}
        onClose={() => setLightboxIndex(null)}
        onNavigate={(index) => setLightboxIndex(index)}
      />
    </>
  );
}
